import { FC, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { DateSerializer, Datebox, Textbox } from "capitalrx-components-2.0/lib/forms";
import { Grid, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Subheading } from "capitalrx-components-2.0/lib/typography";
import { ThemedRadioGroup, ThemedSubmitButton } from "@/App/components";

interface PreRegisterFormProps {
  readonly forceFirstNameReadonly: boolean;
  readonly forceLastNameReadonly: boolean;
  readonly forceDateOfBirthReadonly: boolean;
  readonly forceMemberIdReadonly: boolean;
}

export const PreRegisterForm: FC<PreRegisterFormProps> = (props) => {
  const form = useFormContext();
  const registrationMethod = form.watch("registrationMethod");
  const location = useLocation();
  const { t: translate } = useTranslation();

  const { isCompressed } = useResponsive({
    isCompressed: {
      mobile: true,
      desktop: false,
      tablet: false,
    },
  });

  useEffect(() => {
    form.setValue("registrationValue", "");
  }, [registrationMethod]);

  return (
    <Grid testId="validate-member-information-container">
      <Grid.Span columns={12}>
        <Subheading textAlign="center">{translate("REGISTER.preRegisterForm.validateMemberInformationHeading")}</Subheading>
      </Grid.Span>

      <Grid.Span columns={isCompressed ? 12 : 6}>
        <Textbox.Field testId="first-name" readOnly={props.forceFirstNameReadonly} placeholder={translate("REGISTER.preRegisterForm.firstName")} name="firstName" required label={translate("REGISTER.preRegisterForm.firstName")} />
      </Grid.Span>
      <Grid.Span columns={isCompressed ? 12 : 6}>
        <Textbox.Field testId="last-name" readOnly={props.forceLastNameReadonly} placeholder={translate("REGISTER.preRegisterForm.lastName")} name="lastName" required label={translate("REGISTER.preRegisterForm.lastName")} />
      </Grid.Span>

      <Grid.Span columns={12}>
        <Datebox.Field testId="date-of-birth" readOnly={props.forceDateOfBirthReadonly} serializer={DateSerializer.Literal} zone="local" name="dateOfBirth" required label={translate("REGISTER.preRegisterForm.dateOfBirth")} instructions="mm/dd/yyyy" />
      </Grid.Span>

      {location.pathname !== "/sso/register" && (
        <Grid.Span columns={12}>
          <ThemedRadioGroup.Field testId="registration-method" orientation={isCompressed ? "vertical" : "horizontal"} name="registrationMethod" label={translate("REGISTER.preRegisterForm.registerUsing")}>
            <ThemedRadioGroup.Option value="ssn">{translate("REGISTER.preRegisterForm.socialSecurityNumber")}</ThemedRadioGroup.Option>
            <ThemedRadioGroup.Option value="memberId">{translate("REGISTER.preRegisterForm.memberId")}</ThemedRadioGroup.Option>
          </ThemedRadioGroup.Field>
        </Grid.Span>
      )}

      <Grid.Span columns={12}>
        <Textbox.Field
          testId="registration-value"
          name="registrationValue"
          required
          readOnly={props.forceMemberIdReadonly}
          placeholder={registrationMethod === "memberId" ? translate("REGISTER.preRegisterForm.memberId") : "000-00-0000"}
          label={registrationMethod === "ssn" ? translate("REGISTER.preRegisterForm.socialSecurityNumber") : translate("REGISTER.preRegisterForm.memberId")}
          instructions={registrationMethod === "memberId" ? translate("REGISTER.preRegisterForm.memberIdInstruction") : "000-00-0000"}
        />
      </Grid.Span>

      <Grid.Span columns={12}>
        <ThemedSubmitButton testId="validate" appearance="primary" icon="arrow-right" iconPosition="right">
          {translate("REGISTER.preRegisterForm.validate")}
        </ThemedSubmitButton>
      </Grid.Span>
    </Grid>
  );
};
